import { Component, OnInit, Input, Injectable, ViewChild } from '@angular/core';
import { PopupService } from '../../../../services/shared/popup.service';
import { VehicleMakeService } from '../../../../services/vehicle-make.service';
import { VehicleTypeService } from '../../../../services/vehicle-type.service';
import { VehicleService } from '../../../../services/vehicle.service';
import { ToastRef, ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from '../../../../../environments/environment';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl } from '@angular/forms';
import { CountryService } from 'app/services/country.service';
import { VehicleEntryService } from 'app/services/vehicle-entry.service';

import { PermitTypeComponent } from 'app/maintain/permit-type/permit-type.component';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DT_FORMAT = 'DD/MM/YYYY';

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT)
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) return '';
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return '';
    return mdt.format(this.DT_FORMAT);
  }
}
declare var $;
@Component({
  selector: 'app-app-vehicle',
  templateUrl: './app-vehicle.component.html',
  styleUrls: ['./app-vehicle.component.css'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    NgbActiveModal,
  ]
})
export class AppVehicleComponent implements OnInit {
  @Input() dataCntrl: any;
  @ViewChild('closebutton', { static: true }) closebutton;


  currentDate: any = { day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear() } //{ day: "?= date('Y-m-d'); ?" } //
  vehicle: any = {};
  listvehicles: any = [];
  list_vehicle_type: any = [];
  list_vehicle_make: any = [];
  editMode: boolean = false;
  disableAdd: boolean = false;
  max_pass: number = 1000;
  max_limit: number = 14;
  min_pass: number = 0;
  haserror: boolean = false;
  gridload: boolean = false;
  tabload: boolean = false;
  public pageload = false;
  public pageload2 = false;
  disableBtn: boolean = false;
  selectedVMake: any;
  isProcess: boolean = true;
  isSaveAndCon: boolean = false;
  renewalFlag: boolean = false;
  isReplaceVehicle : boolean = false;
  isViewMode :Boolean = false;

  newListvehicles: any = [];
  btnAddNew: boolean = false;
  myForm: UntypedFormGroup;
  ddlCountries = [];
  public isLoading = false;
  leased: any;
  isEditData: boolean = false;
  private modalRef: NgbModalRef;
  eNatisData: any;
  listvehicleEntries: any = [];
  vehiclePermitEntries: any = [];

  message = '';

  customIndex: any;
  myPassenger: any;
  myStartDate: any;
  myVehicleType: any;
  myRegNum: any;
  myGvm: any;
  MyVin: any;
  myExpDAte: any;
  noOfDays: any = 0;
  replaceVehicle: boolean = false;
  isCorrection: boolean = false;
  isDuplicate: boolean = false;
  isAmmendRoute:boolean=false;
  permitStatus13: any;
  constructor(private showModal: PopupService, private vehicleTypeService: VehicleTypeService, private vehicleMakeService: VehicleMakeService,
    private vehicleService: VehicleService, private toastr: ToastrService,
    private applicationService: ApplicationService,
    public utility: UtilityServiceService,private confirmDialogService: ConfirmDialogService,
    private router: Router, private permitService: PermitService, private activeRoute: ActivatedRoute,
    private ngbCalendar: NgbCalendar, private dateAdapter: NgbDateAdapter<string>,
    private datePipe: DatePipe, private permitSevc: PermitService
    , private formBuilder: UntypedFormBuilder, private countryService: CountryService, public activeModal: NgbActiveModal, private entryService: VehicleEntryService) {

  }

  ngOnInit() {
  
    this.isReplaceVehicle = this.router.url.indexOf('change') > 0 && this.router.url.indexOf('vehicle') > 0;

    if(this.isReplaceVehicle)
    {
      this.dataCntrl.application.permit_type_id = 16;
    }

    this.getVehicleType();
    if (this.listvehicles.length > 0) {
      this.dataCntrl.formValid = true;
    }

    //console.log(this.dataCntrl.permittype.permit_days);
    if (this.dataCntrl.permittype.can_specify_duration === true) {
      this.noOfDays = this.dataCntrl.permittype.permit_days
    }
    // this.getVehicleType();
    this.getVehicleMake();
    // this.setVehicles();
    // if(this.dataCntrl.isViewEditControl == true){
    //  // this.editMode = this.dataCntrl.editMode;
    //   this.setVehicles();
    // }
    if (this.router.url.indexOf('new') > 0){
      this.getSavedVehicleByPermit('load');
    }

    if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
      this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
    }

    // if (this.router.url.indexOf('correction') > 0) {
    // }

    //console.log(this.dataCntrl);
    if (this.router.url.indexOf('edit') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
      
        this.getSavedVehicleByPermit('load');
        // this.getPermitAppVehicle(params['id']);

        if (params['type']) {
          this.renewalFlag = true;
        }
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {         
          this.disableBtn = true;          
        }


      });

    }
    this.dataCntrl.changeVehicle=false;
    if (this.router.url.indexOf('view') > 0) {
      this.isViewMode = true;
      this.dataCntrl.application.id = this.activeRoute.params['_value'].id;
      this.isProcess = false;
      this.getSavedVehicleByPermit('load');
      if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
        //this.disableBtn = true;

        //console.log('This is Admin')
      }

    }
    if (this.router.url.indexOf('correction') > 0 || this.dataCntrl.permittype.code == 'OTH-CRR') {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        this.isCorrection = true;

        this.getSavedVehicleByPermit('load');
        // this.getPermitAppVehicle(params['id']);


      });
    }
    if (this.router.url.indexOf('change') > 0) {
      if (this.activeRoute.params['_value'].ctrlType != undefined && this.activeRoute.params['_value'].ctrlType == 'vehicle') {
        this.replaceVehicle = true;
      } else {
        if (this.activeRoute.params['_value'].ctrlType == 'true') {
          this.isAmmendRoute=true;
        }
      }
      this.getSavedVehicleByPermit('load');
    }
    if (this.router.url.indexOf('duplicate') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        this.isDuplicate = true;
        this.getSavedVehicleByPermit('load');
        // this.getPermitAppVehicle(params['id']);


      });
    }
    // if(this.dataCntrl.isSaveAndCon){
    //   this.getSavedVehicleByPermit(this.dataCntrl.permits.application_id,'update');
    // }else{
    //   this.getSavedVehicleByPermit(this.dataCntrl.application.id,'load');
    // }

    // this.getApplication();
    localStorage.setItem('replaceFlag', this.replaceVehicle.toString());
    this.createForm();
    this.listCountries();
    this.getVehicleType();
  }
    viewVehicleEntry() {
      if (this.router.url.indexOf('new') > 0) {
        localStorage.setItem("aplFlag", "new");
        localStorage.setItem("carrierId", this.dataCntrl.carrierID)

      }


    // this.getPermitsAppVecleEntry(this.dataCntrl.application.id);
    //  this.router.navigateByUrl('permit/my-vehicles/'+this.dataCntrl.application.id);vehicle-replace
    if (this.replaceVehicle === true) {      
      return this.router.navigate(['/permit/vehicle-replace', this.dataCntrl.application.id]);
    }
    
    this.router.navigate(['/permit/my-vehicles', this.dataCntrl.application.id]);
  }
  createForm() {
    this.isEditData = false;
    this.myForm = this.formBuilder.group({
      id: [-1, []],
      permit_id: [],
      country_id: ['', [Validators.required]],
      registration_number: [this.myRegNum, [Validators.required]],
      registration_year: ['', [Validators.required]],
      vehicle_make_id: ['', [Validators.required,]],
      vehicle_series: ['', []],
      vehicle_model: ['', []],
      vehicle_colour: ['', []],
      vin: [this.MyVin, [Validators.required,]],
      engine_number: ['', [Validators.required,]],
      gvn: [this.myGvm, [Validators.required,]],
      seating_capacity: ['', []],
      date_license_expiry: [this.myExpDAte, [Validators.required,]],
      start_date: [this.myStartDate, [Validators.required,]],
      vehicle_state: ['', []],
      roadworthy_status: ['', [Validators.required,]],
      vehicle_owner: ['', [Validators.required,]],
      is_leased: ['', [Validators.required,]],
      vehicle_lessor: [''],
      vehicle_lessee: [''],
      date_lease_expiry: [this.myExpDAte],
      vehicle_type_id: [this.myVehicleType, [Validators.required,]],
      vehicle_entry_id: ['', []],
    });
  }
  passForEdit(item) {
    //console.log(item);
    this.isEditData = true;
    this.vehicleService.getVehicleBy(item.id).subscribe((x:any) => {
      //console.log(x);
      this.leased = x.is_leased;
      this.myForm.patchValue({
        id: item.id,
        date_license_expiry: item.date_license_expiry,
        gvn: item.gvn,
        registration_number: item.registration_number,
        seating_capacity: x.seating_capacity,
        start_date: item.start_date,
        vehicle_make_id: item.vehicle_make_id,
        vehicle_type_id: item.vehicle_type_id,
        vin: item.vin,

        permit_id: x.permit_id,
        country_id: x.country_id,
        vehicle_series: x.vehicle_series,
        vehicle_model: x.vehicle_model,
        vehicle_colour: x.vehicle_colour,
        engine_number: x.engine_number,
        vehicle_state: x.vehicle_state,
        roadworthy_status: x.roadworthy_status,
        vehicle_owner: x.vehicle_owner,
        is_leased: x.is_leased,
        vehicle_lessor: x.vehicle_lessor,
        vehicle_lessee: x.vehicle_lessor,
        date_lease_expiry: this.datePipe.transform(x.date_lease_expiry, 'dd/MM/yyyy'),


      });
    })


  }
  backToTab() {
    if(this.router.url.indexOf('duplicate') > 0){
      this.applicationService.setTab(0);
    }
    else{
      this.router.navigate(['/carrier/permit/application/edit/' + this.dataCntrl.application.id]);
      this.applicationService.setTab(1);
    }
  }
  SaveModal() {    
    if (!this.myForm.value.country_id) {
      return this.toastr.warning('Country of vehicle registration is required!', 'Country Of Vehicle Registration');
    }
    if (!this.myForm.value.registration_number) {
      return this.toastr.warning('Vehicle registration number is required!', 'Vehicle Registration Number');
    }
    if (!this.myForm.value.vehicle_make_id) {
      return this.toastr.warning('Vehicle make is required!', 'Vehicle Make');
    }
    if (!this.myForm.value.vin) {
      return this.toastr.warning('VIN or Chassis number is required!', 'VIN or Chassis Number');
    }
    // if(this.myForm.value.vin.length !== 17){
    //   return this.toastr.warning('VIN should be 17 alphanumeric characters.','VIN or Chassis Number')
    // }
    if (!this.myForm.value.engine_number) {
      return this.toastr.warning('Engine number is required!', 'Engine Number');
    }
    if (!this.myForm.value.gvn) {
      return this.toastr.warning('Gross Vehicle(GVM) is required!', 'Gross Vehicle(GVM)');
    }
    if (!this.myForm.value.date_license_expiry) {
      return this.toastr.warning('License expiry date is required!', 'License Expiry Date');
    }    
    if (!this.myForm.value.start_date) {
      return this.toastr.warning('Start Date is required!', 'Permit Start Date');
    }
    if (!this.myForm.value.roadworthy_status) {
      return this.toastr.warning('Roadworthy status is required!', 'Roadworthy Status');
    }
    if (!this.myForm.value.vehicle_type_id) {
      return this.toastr.warning('Vehicle type is required!', 'Vehicle Type');
    }
    if (!this.myForm.value.vehicle_owner) {
      return this.toastr.warning('Vehicle owner name is required!', 'Vehicle Owner Name');
    }
    if (!(parseInt(this.myForm.value.registration_year) >= 1950 && parseInt(this.myForm.value.registration_year) <= 2100)) {
      this.toastr.warning("Invalid Registration Year");
      return false;
    }
    if (this.myForm.value.is_leased === null) {
      return this.toastr.warning('Is the vehicle leased?', 'Vehicle');
    }
    if (this.leased === true || this.leased === 'true') {
      //console.log('inside')
      if (!this.myForm.value.vehicle_lessor) {
        return this.toastr.warning('Lessor name is required!', 'Lessor Name');
      }
      if (!this.myForm.value.vehicle_lessee) {
        return this.toastr.warning('Lessee name is required!', 'Lessee Name');
      }
      if (!this.myForm.value.date_lease_expiry) {
        return this.toastr.warning('Expiry date of lease is required!', 'Expiry Date Of Lease');
      }
    }
    if (this.leased === false || this.leased === 'false') {
      this.myForm.value.vehicle_lessor = '';
      this.myForm.value.vehicle_lessee = '';
      this.myForm.value.date_lease_expiry = '';
    }
    //console.log(this.myForm.value.is_leased)
    if (this.myForm.value.date_license_expiry) {
      let date_license_expiry = this.myForm.value.date_license_expiry
      let date = date_license_expiry.split('/');
      let day = parseInt(date[0], 10);
      let month = parseInt(date[1], 10);
      let year = parseInt(date[2], 10);
      let newDate = year + '/' + month + '/' + day;
      let newDate1 = new Date(newDate);
      newDate1.setDate(newDate1.getDate() + 1);
      this.myForm.value.date_license_expiry = newDate1;
    }


    if (this.myForm.value.date_lease_expiry) {
      let date_lease_expiry = this.myForm.value.date_lease_expiry;
      let date1 = date_lease_expiry.split('/');
      let day1 = parseInt(date1[0], 10);
      let month1 = parseInt(date1[1], 10);
      let year1 = parseInt(date1[2], 10);
      let newDate2 = year1 + '/' + month1 + '/' + day1;
      let newDate11 = new Date(newDate2);
      newDate11.setDate(newDate11.getDate() + 1);
      this.myForm.value.date_lease_expiry = newDate11;
    }

    if (this.myForm.value.start_date) {
      let start_date = this.myForm.value.start_date;
      let date20 = start_date.split('/');
      let day20 = parseInt(date20[0], 10);
      let month20 = parseInt(date20[1], 10);
      let year20 = parseInt(date20[2], 10);
      let newDate20 = year20 + '/' + month20 + '/' + day20;
      let newDate110 = new Date(newDate20);
      newDate110.setDate(newDate110.getDate() + 1);
      this.myForm.value.start_date = newDate110;
    }


    this.myForm.value.date_modified = new Date(),
      this.myForm.value.date_created = new Date(),
      this.myForm.value.user_modified = this.myForm.value.user_created = environment.authWebApi.userData.User.FirstName,

      //console.log(this.customIndex);
    this.pageload = true;
    //this.dataCntrl.permits.date_11 = this.myForm.value.start_date;
    //this.dataCntrl.permits.number_passengers = this.myPassenger;
    if (this.myForm.value.id === -1) {
      if (this.customIndex === 0) {
      
        this.dataCntrl.permits.forEach(permit => {
          if(permit.id <= 0)
          {
            permit.date_11 = this.myForm.value.start_date;
            permit.number_passengers = this.myPassenger;
            this.permitService.putAppPermit(permit, this.noOfDays).subscribe((result:any) => {

              this.myForm.value.permit_id = result.id;
              this.entryService.vehicleApplicationForeign(this.myForm.value, this.dataCntrl.carrierID).subscribe((entry:any) => {
                this.myForm.value.vehicle_entry_id = entry.id;
                this.vehicleService.updateVehicle(this.myForm.value).subscribe(x => {
                  this.closebutton.nativeElement.click();
                  this.toastr.success('Saved Vehicle Successfully', 'Vehicle');
                  setTimeout(() => { this.getSavedVehicleByPermit(''); }, 2000);
                  this.pageload = false;

                })


              })

            });
          }
      });
      } else {
        this.dataCntrl.permits.forEach(permit => {
          if(permit.id <= 0) {
          permit.date_11 = this.myForm.value.start_date;
          permit.number_passengers = this.myPassenger;
        this.permitService.postAppPermit(permit, this.noOfDays).subscribe((result:any) => {
          this.updatePermit(result);
          this.myForm.value.permit_id = result.id;
          this.entryService.vehicleApplicationForeign(this.myForm.value, this.dataCntrl.carrierID).subscribe((entry:any) => {
            this.myForm.value.vehicle_entry_id = entry.id;
            this.vehicleService.updateVehicle(this.myForm.value).subscribe(x => {
              setTimeout(() => { this.getSavedVehicleByPermit(''); }, 400);
              this.pageload = false;
              this.closebutton.nativeElement.click();
              this.toastr.success('Saved Vehicle Successfully', 'Vehicle');
            })

          })

        });
      }
      });
      }



    }
    else {
     
      this.dataCntrl.permits.forEach(permit => {
        if(permit.id <= 0) {
        permit.date_11 = this.myForm.value.start_date;
        permit.number_passengers = this.myPassenger;
      this.permitService.putAppPermit(permit, this.noOfDays).subscribe(result => {
        this.vehicleService.updateVehicle(this.myForm.value).subscribe(x => {
          this.closebutton.nativeElement.click();
          this.toastr.success('Saved Vehicle Successfully', 'Vehicle');
          setTimeout(() => { this.getSavedVehicleByPermit(''); }, 5000);
          this.pageload = false;

        })
      });
    }
    });

    }

  }
  LeaseChange() {
    this.leased = this.myForm.value.is_leased;
  }
  listCountries() {
   
    this.isLoading = true;
    this.countryService.listCountries().subscribe((result:any) => {
      
      this.ddlCountries = result;
      this.isLoading = false;
    }, error => {
      this.isLoading = false;

    });
  }

  getApplication() {

    if (this.dataCntrl.application.id !== null && this.dataCntrl.application.id !== undefined && this.dataCntrl.vehicles.length == 0) {
      this.applicationService.getById(this.dataCntrl.application.id).subscribe((data:any) => {
        //console.log(data);
        this.pageload = false;

        for (let i = 0; i < data.vehicle.length; i++) {
          let object = {
            id: data.vehicle[i].id,
            vehicle_type_id: data.vehicle[i].vehicle_type_id,
            vehicle_make_id: data.vehicle[i].vehicle_make_id,
            vehicle_make: data.vehicle[i].vehicle_make,
            vehicle_type: data.vehicle[i].vehicle_type,
            is_current: false,
            registration_number: data.vehicle[i].registration_number,
            // seating_capacity: data.vehicle[i].seating_capacity,
            number_passengers: data.vehicle[i].number_passengers,
            gvn: data.vehicle[i].gvn,
            vin: data.vehicle[i].vin,
            date_license_expiry: this.datePipe.transform(data.vehicle[i].date_license_expiry, 'dd/MM/yyyy'),
            start_date: this.datePipe.transform(data.vehicle[i].start_date, 'dd/MM/yyyy'),
            // date_from:data.vehicle[i].date_from,
            editMode: false,
            permit_num: data.vehicle[i].permit_id == null? "" : data.permit.find(p=>p.id ==data.vehicle[i].permit_id).permit_num
          }
          // if(this.listvehicles.length === data.vehicle.length){
          //   //console.log('Its 0')
          // //  this.listvehicles.push(object);
          //    this.listvehicles = this.dataCntrl.vehicles ;

          //   return;
          // }
          //console.log(object);
          //console.log(this.listvehicles)


          // this.listvehicles.push(object);





        }
        //console.log(this.vehicle);



        this.dataCntrl.carrierID = data.carrier_id;

      })
    } else {
      
      this.pageload = false;
      for (let list of this.dataCntrl.vehicles) {
        let object = {
          id: list.id,
          vehicle_type_id: list.vehicle_type_id,
          vehicle_make_id: list.vehicle_make_id,
          vehicle_make: list.vehicle_make,
          vehicle_type: list.vehicle_type,
          is_current: false,
          registration_number: list.registration_number,
          // seating_capacity:list.seating_capacity,
          number_passengers: list.number_passengers,
          gvn: list.gvn,
          vin: list.vin,
          date_license_expiry: list.date_license_expiry,
          start_date: list.start_date,
          // date_from:list.date_from,
          editMode: false
        }
        if (this.isCorrection === true || this.isDuplicate === true ||  this.replaceVehicle === true || this.isAmmendRoute) {
          object.editMode = true;
        }
        this.listvehicles.push(object);


      }
    }

  }
  getPermitAppVehicle(id) {
    this.vehicleService.getPermitsAppVecle(id).subscribe((data:any) => {
      //console.log(data);
      data.forEach(vehicles => {
        let object = {
          id: vehicles.id,
          vehicle_type_id: vehicles.vehicle_type_id,
          vehicle_make_id: vehicles.vehicle_make_id,
          vehicle_make: vehicles.vehicle_make,
          vehicle_type: vehicles.vehicle_type,
          is_current: false,
          registration_number: vehicles.registration_number,
          // seating_capacity:vehicles.seating_capacity,
          permit_id: vehicles.permit_id,
          number_passengers: vehicles.number_passengers,
          gvn: vehicles.gvn,
          vin: vehicles.vin,
          date_license_expiry: this.datePipe.transform(vehicles.date_license_expiry, 'dd/MM/yyyy'),
          start_date: this.datePipe.transform(vehicles.start_date, 'dd/MM/yyyy'),
          editMode: false
        };
        this.listvehicleEntries.push(object);
      });
      //console.log(this.listvehicleEntries);


    })





  }//getPermitsAppVecleEntry
  getPermitsAppVecleEntry(id) {
    this.pageload = true;
    this.vehicleService.getPermitsAppVecleEntry(id).subscribe(data => {
      //console.log(data);
      this.vehiclePermitEntries = data
      this.pageload = false;
    })

  }

  getSavedVehicleByPermit(loadType) {


    // this.getVehicleType();


    this.pageload = true;
    this.listvehicles = [];
    localStorage.removeItem('checkVehicle');
    if (this.replaceVehicle === true){
      localStorage.removeItem('replacements');
      localStorage.setItem('replacements',JSON.stringify(this.listvehicles));
      this.vehicleService.setVehicleReplament(this.listvehicles);
    }
    localStorage.setItem('checkVehicle',JSON.stringify(this.listvehicles));
    this.permitSevc.getAllPermitsByApplicationId(this.dataCntrl.application.id).subscribe((data:any) => {
      // //console.log(data.filter(i => i.application_id == this.dataCntrl.application.id));
      // let permits = data.filter(i => i.application_id == this.dataCntrl.application.id);
      let permits = data;
      this.vehicleService.getPermitsAppVecle(this.dataCntrl.application.id).subscribe((x: any) => {
        this.listvehicles = [];
        if (permits.length > 0) {
          for (let p = 0; p < permits.length; p++) {
            //console.log(permits[p].id)
            let perm = permits[p];
            //console.log(x.filter(i => i.permit_id == permits[p].id))
            let allVeh = x.filter(i => i.permit_id == perm.id);

            //console.log(x.find(i => i.permit_id == permits[p].id))

            if (allVeh.length > 0) {
             
              for (let v = 0; v < allVeh.length; v++) {
                let vehicles = allVeh[v];                
                let object = {
                  id: vehicles.id,
                  vehicle_type_id: vehicles.vehicle_type_id,
                  vehicle_make_id: vehicles.vehicle_make_id,
                  vehicle_make: vehicles.vehicle_make,
                  vehicle_type: vehicles.vehicle_type,
                  is_current: false,
                  registration_number: vehicles.registration_number,
                  // seating_capacity:vehicles.seating_capacity,
                  permit_id: vehicles.permit_id,
                  number_passengers: vehicles.number_passengers > 0 ? vehicles.number_passengers : vehicles.seating_capacity,
                  seating_capacity: vehicles.seating_capacity,
                  gvn: vehicles.gvn,
                  vin: vehicles.vin,
                  date_license_expiry: this.datePipe.transform(vehicles.date_license_expiry, 'dd/MM/yyyy'),
                  start_date: this.datePipe.transform(vehicles.start_date, 'dd/MM/yyyy'),
                  editMode: false,
                  withoutVehicle: vehicles.vin == null ? true : false,
                  permit_num: perm.permit_num
                }
                if(loadType=='load' && this.isAmmendRoute && (!this.dataCntrl.oldPermitStartDate || this.dataCntrl.oldPermitStartDate==null)){
                  this.dataCntrl.oldPermitStartDate=vehicles.start_date;
                }
                let permitData: any = permits.filter((map) => { return map.id == vehicles.permit_id });
                let days: any = this.dataCntrl.permittype.permit_days;
                if (permitData != null && permitData.length > 0) {
                  if (permitData[0].date_valid_from != null && permitData[0].date_valid_to != null) {
                    let from_date: any = new Date(permitData[0].date_valid_from);
                    let to_date: any = new Date(permitData[0].date_valid_to);

                    if (from_date != undefined && to_date != undefined) {
                      days = Math.floor((Date.UTC(to_date.getFullYear(), to_date.getMonth(), to_date.getDate()) - Date.UTC(from_date.getFullYear(), from_date.getMonth(), from_date.getDate())) / (1000 * 60 * 60 * 24));
                      //console.log("------+" + days);
                    }
                  }
                }

                object['noOfDays'] = days;
                // if (this.renewalFlag == true && loadType == 'load') {
                //   object.id = -1;
                // }
                //console.log(object)
                //   if(this.listvehicles.length === data.vehicle.length){
                // //console.log('Its 0')
                //  this.listvehicles = this.dataCntrl.vehicles ;
                //  this.pageload = false;

                // return;
                //   }
                if (this.isCorrection === true || this.isDuplicate === true ||  this.replaceVehicle === true || this.isAmmendRoute) {
                  object.editMode = true;
                }
                this.listvehicles.push(object);
                this.pageload = false;

                //console.log('Inside first vehicle', this.listvehicles)

                if (this.applicationService.vehicleLoadCount == 0) {
                  this.applicationService.vehiclesControlTrackChanges = this.listvehicles;
                  this.applicationService.vehicleLoadCount = 1;
                } else {
                  this.applicationService.vehicleAdded = this.applicationService.vehiclesControlTrackChanges.length != this.listvehicles.length;
                }
                //console.log(this.applicationService.vehicleAdded);
                //console.log(this.listvehicles);
                //console.log(this.applicationService.vehiclesControlTrackChanges);

                this.listvehicles.sort(function (a, b) {
                  if (a.id < b.id) { return -1; }
                  if (a.id > b.id) { return 1; }
                  return 0;
                })

                this.dataCntrl.vehicles = this.listvehicles;

                // }, error => {
                //   this.pageload = false;
                //   //console.log(this.listvehicles);
                //   this.dataCntrl.vehicles = this.listvehicles;
                // })

              }

              //console.log(this.listvehicles)
              if (this.replaceVehicle === true){
                localStorage.setItem('replacements',JSON.stringify(this.listvehicles));
                this.vehicleService.setVehicleReplament(this.listvehicles);
              }
              localStorage.setItem('checkVehicle',JSON.stringify(this.listvehicles));

            }

            this.pageload = false;
            this.dataCntrl.vehicles = this.listvehicles;

          }

        } else {
          this.pageload = false;
          //console.log(this.listvehicles);
          this.dataCntrl.vehicles = this.listvehicles;


        }

        // this.newListvehicles.push(x)
        //  //console.log(this.newListvehicles)
        //  this.dataCntrl.vehicles = this.newListvehicles
        // //  this.listvehicles = this.dataCntrl.vehicles;



      }, error => {
        this.pageload = false;
        //console.log(this.listvehicles);
        this.dataCntrl.vehicles = this.listvehicles;
      })


    }, error => {
      this.pageload = false;
      //console.log(this.listvehicles);
      this.dataCntrl.vehicles = this.listvehicles;
    })

  }
  sortBy(prop) {
    // let newArr = []
    //           this.listvehicles.forEach((item, index) => {
    //               if (newArr.findIndex(i => i.id == -1) === -1)
    //               {
    //                   newArr.push(item)
    //               }
    //           });
    //           this.listvehicles = newArr;
    return this.listvehicles.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);

  }
  // ngOnChanges(){
  //   //console.log(this.dataCntrl.application.permit_type_id);
  //   this.getVehicleType();
  // }
  getVehicleType() {
    this.isLoading = false;
    this.pageload2 = true
    this.vehicleTypeService.getPermitTypeVehicles().subscribe(result => {
      this.list_vehicle_type = result;//.filter(x => x.permit_type_id === this.dataCntrl.application.permit_type_id);
      
      this.pageload2 = false;
      if (this.list_vehicle_type.length > 0) {
        this.btnAddNew = true
      }
      //console.log(this.btnAddNew)
      //console.log(this.list_vehicle_type.length)
      this.isLoading = false;
    }, error => {
      //console.log(error);
      this.isLoading = false
      this.pageload2 = false;
    });
  }

  getVehicleMake() {
    if (this.list_vehicle_make.length <= 0)
      this.vehicleMakeService.getAll().subscribe((result: any) => {
        this.list_vehicle_make = result
        this.selectedVMake = result.find(x => x.code == 'Unknown');
        //console.log(this.selectedVMake)
      }, error => {
        //console.log(error);
      });
  }

  setVehicles() {
    this.listvehicles = this.dataCntrl.vehicles;
    for (let list of this.listvehicles) {
      if (this.dataCntrl.isViewEditControl == true) {
        //list.editMode=false
      } else {
        list.editMode = true;
      }
    }
  }

  onVehicleTypeSelected(index) {
    if (this.haserror) {
      this.haserror = false;
    }
    let id = this.listvehicles[index].vehicle_type_id;
    var obj = this.list_vehicle_type.find(p => p.vehicle_type_id == id);
    //console.log(obj);
    //console.log(this.list_vehicle_type);
    this.listvehicles[index].vehicle_type = obj.vehicle_type;
    this.max_pass = obj.passengers_max;
    this.min_pass = obj.passengers_min;
    //console.log(this.max_pass);
  }

  onVehicleMakeSelected(index) {
    if (this.haserror === true) {
      this.haserror = false;
    }
    let id = this.listvehicles[index].vehicle_make_id;
    var obj = this.list_vehicle_make.find(p => p.id == id);
    this.listvehicles[index].vehicle_make = obj.description;
  }

  addNew() {

    if (this.renewalFlag) {
      this.listvehicles = [];
    }
    let isValid: boolean = false;
    if (this.listvehicles.length > 0) {
      this.listvehicles.forEach(element => {
        if (element.id == -1) {
          this.toastr.error("Please save and continue", "vehicle");
          isValid = true;
          //this.dataCntrl.permittype.one_start_date_reqd
          return false;
        }
      });
    }
    if (!isValid) {
      if (this.dataCntrl.permittype.one_start_date_reqd === true) {
        if (this.listvehicles.length > 0) {
          this.vehicle = { id: -1, withoutVehicle: true, vehicle_type_id: -1, date_license_expiry: '', vehicle_type: '', vehicle_make_id: -1, vehicle_make: '', is_current: false, registration_number: '', seating_capacity: '', number_passengers: '', gvn: '', vin: '', permit_id: '', editMode: true, start_date: this.listvehicles[0].start_date };

        } else {
          this.vehicle = { id: -1, withoutVehicle: true, vehicle_type_id: -1, date_license_expiry: '', vehicle_type: '', vehicle_make_id: -1, vehicle_make: '', is_current: false, registration_number: '', seating_capacity: '', number_passengers: '', gvn: '', vin: '', permit_id: '', editMode: true, start_date: '' };
        }
        this.editMode = true;
        if (this.editMode) {
          this.listvehicles.push(this.vehicle);
          //this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
        } else {
          this.disableAdd = true;
        }
        return
      }
      this.vehicle = { id: -1, withoutVehicle: true, vehicle_type_id: -1, date_license_expiry: '', vehicle_type: '', vehicle_make_id: -1, vehicle_make: '', is_current: false, registration_number: '', seating_capacity: '', number_passengers: '', gvn: '', vin: '', permit_id: this.dataCntrl.permits.id, editMode: true, start_date: '' };
      this.editMode = true;
      if (this.editMode) {
        this.listvehicles.push(this.vehicle);
        //this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
      } else {
        this.disableAdd = true;
      }

    }

  }

  confirmVehicleDelete(item) {
    
    // this.showModal.showYesNo('Delete Vehicle', `Are you sure you want to remove the vehicle with registration ${item.registration_number} from the permit(s) application?`, `You're about to remove a vehicle...`, 'Yes', 'No')
    //   .subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //       if (item.id > 0) {
    //         this.deleteVehicle(item);
    //         this.vehicleService.removeVehicle(item.id).subscribe(x => {             
    //           console.log(x);
    //         })
    //       }

    //     } else {
    //       return;
    //     }
    //   });
      this.confirmDialogService.confirmThis(`Are you sure you want to remove the vehicle with registration ${item.registration_number} from the permit(s) application?`, () => {  
          
        if (item.id > 0) {
          this.deleteVehicle(item);
          this.vehicleService.removeVehicle(item.id).subscribe(x => {             
            console.log(x);
          })
        }
      
      }, () =>  {  
        return;
      }) 
  }
  alertError(message) {
    this.showModal.showAlert('Vehicle', message)
  }

  deleteVehicle(item) {
    const index: number = this.listvehicles.indexOf(item);
    if (index !== -1) {
      this.listvehicles.splice(index, 1);
      
      localStorage.removeItem('checkVehicle'); 
      if (this.listvehicles.length > 0) {
        localStorage.setItem('checkVehicle', JSON.stringify(this.listvehicles));
      }

     
      //var perm = this.dataCntrl.permits.findIndex()
    let pIndex = this.dataCntrl.permits.findIndex(x=>x.id == item.permit_id);
   
      if (pIndex !== -1) {
        this.dataCntrl.permits.splice(pIndex, 1);
      }
    }

    if (this.listvehicles.length <= 0) {
      this.dataCntrl.formValid = false;
    }
  }

  editVehicle(item) {
    const index: number = this.listvehicles.indexOf(item);
    if (index !== -1) {
      this.listvehicles[index].editMode = true;
      //   let date:any=item.date_license_expiry;
      //   let year:any=parseInt(date.split("-")[0]);
      // let month:any=parseInt(date.split("-")[1]);
      // let day:any=parseInt(date.split("-")[2]);
      //   return this.dateAdapter.toModel({year:year,month:month,day:day});
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  maxValue(event, item): boolean {
    const max = event.target.value;
    if (Number(max + "" + event.key) > item.seating_capacity) {
      event.target.value = max;
      return false;
    }
    return true;

  }

  vehicleSave(item) {
    //this.saveVehicle(item);
  }
  validatePassenger(id,item){

    this.vehicleTypeService.getById(id).subscribe((result:any) => {
      let item_ = result;
      //console.log(item_)
    if (item.number_passengers > item_.passengers_max) {
      this.pageload = false;
      return this.toastr.warning("Maximum number of passengers for this vehicle type is " + item_.passengers_max);
    }
    }, error => {
      //console.log(error);

    });


  }
  saveVehicle(item, getIndex) {
    //console.log(item);
    // this.getVehicleType();
    // let expiryDate:any=""
    // if(item.date_license_expiry!=null && item.date_license_expiry!=""){
    //   expiryDate=item.date_license_expiry.split("-")[2]+"/"+item.date_license_expiry.split("-")[1]+"/"+item.date_license_expiry.split("-")[0];
    // }
    // let startDate:any=""
    // if(item.start_date!=null && item.start_date!=""){
    //   startDate=item.start_date.split("-")[2]+"/"+item.start_date.split("-")[1]+"/"+item.start_date.split("-")[0];
    // }
    // let dateFrom:any=""
    // if(item.date_from!=null && item.date_from!=""){
    //   dateFrom=item.date_from.split("-")[2]+"/"+item.date_from.split("-")[1]+"/"+item.date_from.split("-")[0];
    // }
    if (this.dataCntrl.permittype.can_specify_duration) {
      if (parseInt(item.noOfDays) > this.max_limit) {
        this.pageload = false;
        return this.toastr.warning('Number of Days Should not exceed the limit ' + this.max_limit);
      }
    }



    let newDate1;
    //console.log(item.date_license_expiry);
    if (!item.date_license_expiry) {
      item.date_license_expiry = null;
    }
    if (!item.start_date) {
      item.start_date = null;
    }
    if (item.date_license_expiry != null) {
      let date = item.date_license_expiry.split('/');
      let day = parseInt(date[0], 10);
      let month = parseInt(date[1], 10);
      let year = parseInt(date[2], 10);
      let newDate = year + '/' + month + '/' + day;
      newDate1 = new Date(newDate);
      newDate1.setDate(newDate1.getDate() + 1);
    }
    let newDate2;
    if (item.start_date != null) {
      let date2 = item.start_date.split('/');
      let day2 = parseInt(date2[0], 10);
      let month2 = parseInt(date2[1], 10);
      let year2 = parseInt(date2[2], 10);
      let newDate10 = year2 + '/' + month2 + '/' + day2;
      newDate2 = new Date(newDate10);
      newDate2.setDate(newDate2.getDate() + 1);

    }
    if(this.isDuplicate || this.isAmmendRoute || this.replaceVehicle || this.isCorrection || this.router.url.indexOf('edit')>0){
      this.dataCntrl.permits.forEach(permit => {
        if(permit.id == item.permit_id)
        { 
         
         // permit.id = item.permit_id;
          permit.date_11 = newDate2;
          permit.number_passengers = item.number_passengers;
        
          this.updatePermitStartDate(permit, item.noOfDays);
          return false;
        }
      });
    }

    let object = {
      id: item.id,
      vehicle_type_id: item.vehicle_type_id,
      vehicle_type: item.vehicle_type,
      vehicle_make_id: this.selectedVMake.id,
      vehicle_make: this.selectedVMake.description,
      is_current: true,
      registration_number: !item.withoutVehicle ? this.eNatisData.registration_number : null,
      registration_year: !item.withoutVehicle ? this.eNatisData.registration_year : null,
      vehicle_entry_id: !item.withoutVehicle ? this.eNatisData.vehicle_entry_id : null,
      vehicle_owner: !item.withoutVehicle ? this.eNatisData.vehicle_owner : null,
      vehicle_colour: !item.withoutVehicle ? this.eNatisData.vehicle_colour : null,
      vehicle_model: !item.withoutVehicle ? this.eNatisData.vehicle_model : null,
      seating_capacity: !item.withoutVehicle ? this.eNatisData.seating_capacity : null,
      number_passengers: item.number_passengers,
      gvn: !item.withoutVehicle ? this.eNatisData.gvn : null,
      vin: !item.withoutVehicle ? this.eNatisData.vin : null,
      permit_id: 0,
      noOfDays: item.noOfDays,
      date_license_expiry: !item.withoutVehicle ? this.eNatisData?.date_license_expiry !== null ? newDate1 : this.datePipe.transform(this.eNatisData?.date_license_expiry) : null,
      start_date: newDate2,// this.datePipe.transform(item.start_date),
      // date_from:dateFrom,
      date_modified: new Date(),
      date_created: new Date(),
      user_modified: item.user_created = environment.authWebApi.userData.User.FirstName,
      editMode: true
    }
    // object.date_license_expiry= this.datePipe.transform(item.date_license_expiry);
    // object.start_date=this.datePipe.transform(item.start_date);
    if(this.isDuplicate || this.isAmmendRoute || this.replaceVehicle){
      object.gvn=item.gvn;
      object.date_license_expiry=newDate1;
      object.registration_number=item.registration_number
    }

    
    this.dataCntrl.vehicles = [];
    if (item.id == -1) {
      let check = this.listvehicles.filter(x => x.id != -1 && x.registration_number == item.registration_number && x.registration_number != '');
      if (check.length > 0 && !this.renewalFlag) {
        //console.log(check);
        this.pageload = false;
        return this.toastr.warning('Vehicle Already Exists! Please Enter A Different Vehicle.', 'Vehicle Registration Number')
      }

      if (this.dataCntrl.permittype.temp_long_ind === 2) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastr.warning('Start Date Is Required.', 'Start Date')
        }

        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastr.warning('Vehicle Type Is Required.', 'Vehicle Type')
        }



      }
      // if(this.dataCntrl.permittype.freight_passenger_ind === 2){

      //         if(!object.start_date){
      //           // return this.alertError('Start Date Is Required.')
      //           return this.toastr.warning('Start Date Is Required.','Start Date')
      //         }
      //         if(!object.vehicle_type){
      //           // return this.alertError('Vehicle Type Is Required.')
      //           return this.toastr.warning('Vehicle Type Is Required.','Vehicle Type')
      //         }
      //         if(!object.seating_capacity){
      //           // return this.alertError('Vehicle Seating Capacity Is Required.')
      //           return this.toastr.warning('Vehicle Seating Capacity Is Required.','Vehicle Seating Capacity')
      //         }

      // }
      if (this.dataCntrl.permittype.temp_long_ind === 1) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastr.warning('Start Date Is Required.', 'Start Date')
        }
        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastr.warning('Vehicle Type Is Required.', 'Vehicle Type')
        }
        if (!item.withoutVehicle) {
          if (!object.registration_number) {
            // return this.alertError('Vehicle Registration Number Is Required.')
            this.pageload = false;
            return this.toastr.warning('Vehicle Registration Number Is Required.', 'Vehicle Registration Number')
          }

          if (!object.gvn) {
            // return this.alertError('Vehicle GVM Is Required.');
            this.pageload = false;
            return this.toastr.warning('Vehicle GVM Is Required.', 'Vehicle GVM')
          }
          if (!object.vin) {
            // return this.alertError('Vehicle VIN Is Required.')
            this.pageload = false;
            return this.toastr.warning('Vehicle VIN Is Required.', 'Vehicle VIN')
          }
          if (object.vin.length !== 17) {
            // return this.alertError('Vehicle VIN Is Required.')
            this.pageload = false;
            return this.toastr.warning('VIN should be 17 alphanumeric characters.', 'Vehicle VIN')
          }
          if (object.date_license_expiry === null || object.date_license_expiry === undefined) {
            // return this.alertError('Date License Expiry Is Required.')
            this.pageload = false;
            return this.toastr.warning('Date License Expiry Is Required.', 'Date License Expiry')
          }
        }
        // if(!object.date_from){
        //   return this.toastr.warning('Date From Is Required.','Date From')

        // }



      }
      this.haserror = false;
      item.editMode = false;
      this.disableAdd = false;
      this.dataCntrl.formValid = true;
      const index: number = this.listvehicles.indexOf(item);
      this.listvehicles[index] = item;
      //save vehicle
      this.pageload = true;
      
      if (item.withoutVehicle) {
        object['noOfDays'] = 14;
      }

      if (getIndex == 0) {
       
        this.dataCntrl.permits.forEach(permit => {
          if(permit.id == item.permit_id) 
        {
          permit.date_11 = object.start_date;
          permit.number_passengers = object.number_passengers;
          this.permitService.putAppPermit(permit, object['noOfDays']).subscribe((result:any) => {
          //console.log(result);
          //  this.dataCntrl.permit = result;

          object.permit_id = result.id
          //console.log(object.permit_id);
          this.vehicleService.updateVehicle(object).subscribe(result => {
            setTimeout(() => { this.getSavedVehicleByPermit(''); }, 400);
            //console.log(result);
            // this.dataCntrl.vehicles = result;
            this.tabload = false;
            this.toastr.success('Saved Vehicle Successfully', 'Vehicle');


            if (this.isSaveAndCon == true) {
              this.dataCntrl.isSaveAndCon = true;
              this.applicationService.setTab(3);

            }
            const index: number = this.listvehicles.indexOf(item);
            // if(index!=null && index!=undefined  && index!=-1){
            //   this.listvehicles[index].id=result.id;
            // }
            this.dataCntrl.vehicles = this.listvehicles;
            //  this.updateVehiclelist(result);
          },
            error => {
              this.pageload = false;
              this.tabload = false;
              // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
              this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Vehicle');

              return;
            });
        });
      }
      });
      } else {
       
        this.dataCntrl.permits.forEach(permit => {
          if(permit.id == item.permit_id)
          {
          
            this.permitService.postAppPermit(permit, object['noOfDays']).subscribe((result:any) => {
              //console.log(result);
              //  this.dataCntrl.permit = result;
              this.updatePermit(result);
              object.permit_id = result.id
              //console.log(object.permit_id);
              this.vehicleService.updateVehicle(object).subscribe(result => {
                setTimeout(() => { this.getSavedVehicleByPermit(''); }, 400);
                //console.log(result);
                // this.dataCntrl.vehicles = result;
                this.tabload = false;
                this.toastr.success('Saved Vehicle Successfully', 'Vehicle');
    
    
                if (this.isSaveAndCon == true) {
                  this.dataCntrl.isSaveAndCon = true;
                  this.applicationService.setTab(3);
    
                }
                const index: number = this.listvehicles.indexOf(item);
                // if(index!=null && index!=undefined  && index!=-1){
                //   this.listvehicles[index].id=result.id;
                // }
                this.dataCntrl.vehicles = this.listvehicles;
                //  this.updateVehiclelist(result);
              },
                error => {
                  this.pageload = false;
                  this.tabload = false;
                  // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                  this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Vehicle');
    
                  return;
                });
            });
          }
          
        });
        
      }


    } else  {
  
      if (this.dataCntrl.permittype.temp_long_ind === 2) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastr.warning('Start Date Is Required.', 'Start Date')

        }
        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastr.warning('Vehicle Type Is Required.', 'Vehicle Type')
        }

      }
      // if(this.dataCntrl.permittype.freight_passenger_ind === 2){
      //   if(!object.start_date){
      //     // return this.alertError('Start Date Is Required.')
      //     return this.toastr.warning('Start Date Is Required.','Start Date')
      //   }
      //   if(!object.vehicle_type){
      //     // return this.alertError('Vehicle Type Is Required.')
      //     return this.toastr.warning('Vehicle Type Is Required.','Vehicle Type')
      //   }
      //   if(!object.seating_capacity){
      //     // return this.alertError('Vehicle Seating Capacity Is Required.')
      //     return this.toastr.warning('Vehicle Seating Capacity Is Required.','Vehicle Seating Capacity')
      //   }

      // }
      if (this.dataCntrl.permittype.temp_long_ind === 1) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastr.warning('Start Date Is Required.', 'Start Date')
        }
        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastr.warning('Vehicle Type Is Required.', 'Vehicle Type')
        }
        if (!item.withoutVehicle) {
          if (!object.registration_number) {
            // return this.alertError('Vehicle Registration Number Is Required.')
            this.pageload = false;
            return this.toastr.warning('Vehicle Registration Number Is Required.', 'Vehicle Registration Number')
          }
          // if(!object.seating_capacity){
          //   return this.toastr.warning('Vehicle Seating Capacity Is Required.','Vehicle Seating Capacity')
          // }
          if (!object.gvn) {
            // return this.alertError('Vehicle GVN Is Required.')
            this.pageload = false;
            return this.toastr.warning('Vehicle GVM Is Required.', 'Vehicle GVM')
          }
          if (!object.vin) {
            // return this.alertError('Vehicle VIN Is Required.')
            this.pageload = false;
            return this.toastr.warning('Vehicle VIN Is Required.', 'Vehicle VIN')
          }
          // if(object.vin.length !== 17){
          //   // return this.alertError('Vehicle VIN Is Required.')
          //   this.pageload = false;
          //   return this.toastr.warning('VIN should be 17 alphanumeric characters.','Vehicle VIN')
          // }
          if (object.date_license_expiry === null || object.date_license_expiry === undefined) {
            // return this.alertError('Date License Expiry Is Required.')
            this.pageload = false;
            return this.toastr.warning('Date License Expiry Is Required.', 'Date License Expiry')
          }
        }
        // if(!object.date_from){
        //   return this.toastr.warning('Date From Is Required.','Date From')

        // }



      }
      this.haserror = false;
      item.editMode = false;
      this.disableAdd = false;
      this.dataCntrl.formValid = true;
      const index: number = this.listvehicles.indexOf(item);

      this.listvehicles[index] = item;

      //save vehicle
      this.pageload = true;

      //Start Date update
      if (this.listvehicles.length > 0) {
        if (this.dataCntrl.permittype.one_start_date_reqd === true) {

          if (index === 0) {

            for (let i = 0; i < this.listvehicles.length; i++) {
              this.listvehicles[i].start_date = object.start_date;

              let date = this.listvehicles[i].date_license_expiry.split('/');
              let day = parseInt(date[0], 10);
              let month = parseInt(date[1], 10);
              let year = parseInt(date[2], 10);
              let newDate = year + '/' + month + '/' + day;
              newDate1 = new Date(newDate);
              newDate1.setDate(newDate1.getDate() + 1);

              this.listvehicles[i].date_license_expiry = newDate1



            }
            //console.log(this.listvehicles)
            this.vehicleService.postVehicleStartDate(this.listvehicles).subscribe(x => {
              //console.log(x);
              this.tabload = false;
              this.toastr.success('Saved Vehicle Successfully', 'Vehicle');
              this.getSavedVehicleByPermit('');

            }, erro => {
              //console.log(erro);
              return

            })






            // return this.updateByStartDate(this.listvehicles);
          }

        }
      }
      if (this.dataCntrl.permittype.one_start_date_reqd === false) {
        //console.log(item)
        // let object = {
        //   id: item.id,
        //   vehicle_type_id: item.vehicle_type_id,
        //   vehicle_type:item.vehicle_type,
        //   vehicle_make_id: this.selectedVMake.id,
        //   vehicle_make:  this.selectedVMake.description,
        //   is_current: true,
        //   registration_number: item.registration_number,
        //   // seating_capacity: item.seating_capacity,
        //   number_passengers: item.number_passengers,
        //   gvn: item.gvn,
        //   vin: item.vin,
        //   permit_id : item.permit_id,
        //   date_license_expiry:newDate1,// this.datePipe.transform(item.date_license_expiry),
        //   start_date:newDate2,// this.datePipe.transform(item.start_date),
        //   // date_from:dateFrom,
        //   date_modified : new Date(),
        //   date_created : new Date(),
        //   user_modified : item.user_created = environment.authWebApi.userData.User.FirstName,
        //   editMode:true
        // }
        let object = {
          id: item.id,
          vehicle_type_id: item.vehicle_type_id,
          vehicle_type: item.vehicle_type,
          vehicle_make_id: this.selectedVMake.id,
          vehicle_make: this.selectedVMake.description,
          is_current: true,
          registration_number: !item.withoutVehicle ? this.eNatisData.registration_number : null,
          registration_year: !item.withoutVehicle ? this.eNatisData.registration_year : null,
          vehicle_entry_id: !item.withoutVehicle ? this.eNatisData.vehicle_entry_id : null,
          vehicle_owner: !item.withoutVehicle ? this.eNatisData.vehicle_owner : null,
          vehicle_colour: !item.withoutVehicle ? this.eNatisData.vehicle_colour : null,
          vehicle_model: !item.withoutVehicle ? this.eNatisData.vehicle_model : null,
          seating_capacity: !item.withoutVehicle ? this.eNatisData.seating_capacity : null,
          number_passengers: item.number_passengers,
          gvn: !item.withoutVehicle ? this.eNatisData.gvn : null,
          vin: !item.withoutVehicle ? this.eNatisData.vin : null,
          permit_id: item.permit_id,
          noOfDays: item.noOfDays,
          date_license_expiry: !item.withoutVehicle ? this.eNatisData?.date_license_expiry !== null ? newDate1 : this.datePipe.transform(this.eNatisData?.date_license_expiry) : null,//newDate1,// this.datePipe.transform(item.date_license_expiry),
          start_date: newDate2,// this.datePipe.transform(item.start_date),
          // date_from:dateFrom,
          date_modified: new Date(),
          date_created: new Date(),
          user_modified: item.user_created = environment.authWebApi.userData.User.FirstName,
          editMode: true
        }




        this.dataCntrl.permits.forEach(permit => {
         
          if(permit.id == item.permit_id)
        {
          
        permit.date_11 = object.start_date;
        permit.number_passengers = object.number_passengers;
        permit.id = object.permit_id;
     
        
          this.permitService.putAppPermit(permit, object['noOfDays']).subscribe(prm => {
           
            this.permitService.upadatePermit(permit).subscribe((result:any) => {
              //  this.dataCntrl.permit = result;
              object.permit_id = result.id
              //console.log(object.permit_id);
              this.vehicleService.updateVehicle(object).subscribe((result:any) => {
                // setTimeout(()=>{this.getSavedVehicleByPermit('');},400);
                //console.log(result);
                // this.listvehicles.push(result);
                // this.dataCntrl.vehicles = result;
                let days: any = this.noOfDays;
                if (result != null) {
                  let from_date: any = new Date(result.date_valid_from);
                  let to_date: any = new Date(result.date_valid_to);
  
                  if (from_date != undefined && to_date != undefined) {
                    days = Math.floor((Date.UTC(to_date.getFullYear(), to_date.getMonth(), to_date.getDate()) - Date.UTC(from_date.getFullYear(), from_date.getMonth(), from_date.getDate())) / (1000 * 60 * 60 * 24));
                    //console.log("------+" + days);
                  }
                }
  
                object['noOfDays'] = days;
                this.pageload = false;
                this.tabload = false;
                this.toastr.success('Updated Vehicle Successfully', 'Vehicle');
  
             
                if (this.isSaveAndCon == true) {
                  this.dataCntrl.isSaveAndCon = true;
                  this.applicationService.setTab(3);
        
                }

                const index: number = this.listvehicles.indexOf(item);
                // if(index!=null && index!=undefined  && index!=-1){
                //   this.listvehicles[index].id=result.id;
                // }
                this.dataCntrl.vehicles = this.listvehicles;
                //  this.updateVehiclelist(result);
              },
                error => {
                  this.pageload = false;
                  this.tabload = false;
                  // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                  this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Vehicle');
  
                  return;
                });
            });
          });
        }
     
        });
        
       
      }


    }
    // }
  }


  cancelVehicle(item) {
    this.pageload = true;
    //console.log(item)
    if (item.id == -1) {
      const index: number = this.listvehicles.indexOf(item);
      if (index !== -1) {
        this.listvehicles.splice(index, 1);
      }
      this.disableAdd = false;
    } else {
      item.editMode = false;
      this.disableAdd = false;
    }
    this.pageload = false;
  }

  saveVehicles() {
    this.pageload = true;
      this.tabload = true;
      this.isSaveAndCon = true;
      this.dataCntrl.isSaveAndCon = true;
      this.dataCntrl.isVehicleSave = true;

    if(!this.isDuplicate && !this.replaceVehicle && !this.isAmmendRoute && !this.isCorrection){
      for (let i = 0; i < this.listvehicles.length; i++) {
        if (this.listvehicles[i].number_passengers <= 0) {
          this.pageload = false;
          return this.toastr.warning('The vehicle with registration ' + this.listvehicles[i].registration_number + ' can not have zero or less passengers')
        } else {
          // Task 35 - 2021-05-28
          // Validate the vehicle number of passengers against the maximum number of passengers for the vehicle type
          let id = this.listvehicles[i].vehicle_type_id;
          var obj = this.list_vehicle_type.find(p => p.vehicle_type_id == id);
          if (obj != undefined && obj != null) {
            if (this.listvehicles[i].number_passengers > obj.passengers_max) {
              this.toastr.warning(`Maximum number of passengers for this vehicle type is ${obj.passengers_max}`, `${this.listvehicles[i].registration_number}`);
              this.editVehicle(this.listvehicles[i]);
              this.pageload = false;
              return
            }
          } else {
            this.toastr.warning(`There was a problem adding vehicle ${this.listvehicles[i].registration_number} to the permit application. Please try reloading the vehicle...`, `Add Vehicle(s)`);
            this.pageload = false;
            return
          }
        }
      }
    }
  
      for (let i = 0; i < this.listvehicles.length; i++) {
        if (this.listvehicles[i].id === -1 && !this.renewalFlag) {
          this.pageload = false;
          return this.toastr.warning('You have unsaved vehicle! Please save it.');
        }
        if (this.renewalFlag && this.listvehicles[i].id == -1) {
         
          this.eNatisCheck(this.listvehicles[i], i);
          //this.saveVehicle(this.listvehicles[i], i);
        }
        if(this.isDuplicate || this.replaceVehicle || this.isAmmendRoute || this.isCorrection || this.router.url.indexOf('edit')>0 ){
         
          this.eNatisCheck(this.listvehicles[i], i);
          //this.saveVehicle(this.listvehicles[i],i);
        }
      }
      if (this.listvehicles.length <= 0) {
        //   this.listvehicles.forEach(element=>{
        //       this.saveVehicle(element);
        //   });
        if (this.dataCntrl.permittype.temp_long_ind === 1 || (this.dataCntrl.permittype.temp_long_ind === 2 && this.dataCntrl.permittype.freight_passenger_ind === 1) || this.dataCntrl.application.status_id == this.permitStatus13) {
          this.pageload = false;
          return this.toastr.warning('Please add a vehicle to continue');

        }
      }
     
      

      if (this.dataCntrl.permit  !== undefined && this.dataCntrl.permit!== null && this.dataCntrl.permits.length > 0) {
        if (this.replaceVehicle) {
          const nextPos = this.utility.nextTabPosition(this.utility.sequenceNumbers.motivationNum);
          this.applicationService.setTab(nextPos);
        } else {
         
          this.applicationService.setTab(3);
        }
      }

      //console.log(this.dataCntrl.vehicles);
      if (this.dataCntrl.application.id !== null && this.dataCntrl.application.id !== undefined) {
        if (!this.haserror) {
          // return this.applicationService.setTab(3);
        }

      }
      this.dataCntrl.vehicles.forEach(element => {

        //element.permit_id = this.dataCntrl.permits.id;
        element.date_modified = element.date_created = new Date();
        element.user_modified = element.user_created = environment.authWebApi.userData.User.Username;
      });
      if (this.dataCntrl.application.id == undefined) {
        //this.saveApplication();
        this.pageload = false;
        this.toastr.warning('Please select permit type to continue');

      } else {
        this.pageload = false;
        if (!this.haserror) {
          // this.applicationService.setTab(3);
        }

        //     this.vehicleService.postVehicle(this.dataCntrl.vehicles)
        //     .subscribe(result => {
        //       this.pageload = false;
        //     this.dataCntrl.vehicles = result;
        //     this.tabload = false;
        // this.toastr.success('Saved Vehicle Successfully','Vehicle');
        //    this.updateVehiclelist(result);
        //     },
        //     error => {
        //       this.pageload = false;
        //       this.tabload = false;
        //     // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        //         this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.','Vehicle');

        //     return;
        //     });
      }
      
    // }, 7000);
  }

  UpdateVehicle() {
    this.dataCntrl.vehicles.forEach(element => {
      element.permit_id = this.dataCntrl.permits.id;
      element.date_modified = element.date_created = new Date();
      element.user_modified = element.user_created = environment.authWebApi.userData.User.Username;
    });
    this.vehicleService.updateVehicle(this.dataCntrl.vehicles).subscribe(result => {
      this.pageload = false;
      this.dataCntrl.vehicles = result;
      this.tabload = false;
      this.toastr.success('Saved Vehicle Successfully', 'Vehicle');
      // this.updateVehiclelist(result);
      //this.getApplication();

    },
      error => {
        this.pageload = false;
        this.tabload = false;
        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Vehicle');

        return;
      })
  }
  updateVehiclelist(data) {
    this.setVehicles();
    this.applicationService.setTab(3);
    this.utility.confirmCtrl = true;
  }
  backtoPermit() {
    this.router.navigate(['/carrier/permit/application/edit/' + this.dataCntrl.application.id]);
    this.applicationService.setTab(1);
  }
  cancelApplication() {
    let prevUrl = localStorage.getItem('previousUrl');
    if (prevUrl.search('/permit/approval') != -1) {
      this.router.navigate(['/permit/approval/']);
    } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
      this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
    } else {
      this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
    }
  }
    // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
      // this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
    // } else {
    //   this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
    //     .subscribe((isConfirmed) => {
    //       if (isConfirmed) {
    //         this.deleteApplication()
    //       } else {
    //         return;
    //       }
    //     });
    // }
  // }
  deleteApplication() {
    //console.log("delete application");
    this.pageload = true;

    this.permitService.deletePermit(this.dataCntrl.permits.id).subscribe(x => {
      //console.log(x);
      this.deleteApp(this.dataCntrl.application.id);
      this.pageload = false;

      this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);

    })
    //this.dataCntrl.application.id
    //this.dataCntrl.permits.id
  }
  deletePermit(id) {
    this.permitService.deletePermit(id).subscribe(x => {
      //console.log(x);
    })

  }
  deleteApp(id) {
    this.applicationService.deleteApplication(id).subscribe(x => {
      //console.log(x);
    })
  }
  viewdate(date) {
    if (date != null) {
      let year: any = date.split("-")[0];
      let month: any = date.split("-")[1];
      let day: any = date.split("-")[2];
      return { year: year, month: month, day: day };
    }
  }
  updateVehicle(object, item) {
    this.vehicleService.updateVehicle(object).subscribe((result:any) => {
      setTimeout(() => { this.getSavedVehicleByPermit(''); }, 400);
      //console.log(result);
      // this.dataCntrl.vehicles = result;
      this.tabload = false;
      this.toastr.success('Saved Permit & Vehicle Successfully', 'Permit & Vehicle');

      if (this.isSaveAndCon == true) {
        this.applicationService.setTab(3);

      }
      const index: number = this.listvehicles.indexOf(item);
      if (index != null && index != undefined && index != -1) {
        this.listvehicles[index].id = result.id;
      }
      this.dataCntrl.vehicles = this.listvehicles;
      //  this.updateVehiclelist(result);
    },
      error => {
        this.pageload = false;
        this.tabload = false;
        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Vehicle');

        return;
      });
  }
  updateByStartDate(object) {

    this.vehicleService.postVehicleStartDate(object).subscribe(result => {
      //console.log(result);
      // this.dataCntrl.vehicles = result;
      setTimeout(() => { this.getSavedVehicleByPermit(''); }, 400);
      this.tabload = false;
      this.toastr.success('Saved Permit & Vehicle Successfully', 'Permit & Vehicle');

    }, erro => {
      //console.log(erro);

    })
  }
  UpdateDeletePermit() {    
    this.pageload = true;
    this.permitService.deleteRouteDoc(this.dataCntrl.permits.id).subscribe(x => {
      //console.log(x);
      //console.log(this.listvehicles)
      for (let i = 0; i < this.listvehicles.length; i++) {

        let date = this.listvehicles[i].date_license_expiry.split('/');
        let day = parseInt(date[0], 10) + 1;
        let month = parseInt(date[1], 10);
        let year = parseInt(date[2], 10);
        let newDate = year + '/' + month + '/' + day;
        let newDate1 = new Date(newDate);
        this.listvehicles[i].date_license_expiry = newDate1

        let date2 = this.listvehicles[i].start_date.split('/');
        let day2 = parseInt(date2[0], 10) + 1;
        let month2 = parseInt(date2[1], 10);
        let year2 = parseInt(date2[2], 10);
        let newDate2 = year2 + '/' + month2 + '/' + day2;
        let newDate3 = new Date(newDate2);
        this.listvehicles[i].start_date = newDate3
      }
      this.vehicleService.deleteVehiclesList(this.listvehicles).subscribe(data => {
        //console.log(data);
        this.getSavedVehicleByPermit('');
      })
      this.pageload = false;

    })
    //this.dataCntrl.application.id
    //this.dataCntrl.permits.id
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  updatePermit(result) {
    // result.permit_num = 100000000 + parseInt(result.id);
    this.permitService.upadatePermit(result).subscribe(res => {

    })
  }
  updatePermitStartDate(permit, noOfDays){
   
      this.permitService.putAppPermit(permit, noOfDays).subscribe(result => {
      setTimeout(() => { this.getSavedVehicleByPermit(''); }, 400);
      });

  }
  eNatisCheck(item, index) {
    this.myPassenger = item.number_passengers;
    this.myStartDate = item.start_date;
    this.myVehicleType = item.vehicle_type_id;
    this.myRegNum = item.registration_number;
    this.myGvm = item.gvn;
    this.MyVin = item.vin;
    this.myExpDAte = item.date_license_expiry;
    let data = null;
    this.pageload = true;

        // this.validatePassenger(item.vehicle_type_id,item);
        this.vehicleTypeService.getById(item.vehicle_type_id).subscribe((result:any) => {
          let item_ = result;
          //console.log(item_)
        if (item.number_passengers > item_.passengers_max) {
          this.pageload = false;
          return this.toastr.warning("Maximum number of passengers for this vehicle type is " + item_.passengers_max);

        }
        this.entryService.checkVehicleApplication(item, this.dataCntrl.carrierID).subscribe(x => {
          data = x;
          console.log(data)
          if (data.Result === null) {
            this.pageload = false;
            this.customIndex = index;
            this.createForm();
            //console.log(this.myForm.value);
            $("#addEdit").modal('show');

            return this.toastr.info('This vehicle details was not found on eNatis database. Please fill in this form.', 'Vehicle Register')
          } else {
            
            this.eNatisData = data.Result
          
            this.saveVehicle(item, index);
          }

        }, error => {
        });



        }, error => {
          this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Vehicle');
              return;
        });




  }

  checkRoadworthy (event: any) {
    if(event.target.value =!'Roadworthy'){
     if (this.myForm.value.country_id === 113) {
         this.toastr.error('Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.')
       } else {
         this.toastr.error('Please note that according to your selection this vehicle is not roadworthy and therefore will not be eligible for permit application.')
       }
     return
    }
  }

  addApplicatioWithoutVehicle()
    {
      this.applicationService.setTab(3);
    }

}
